import { Unsubscribe } from 'redux';
import actions from '../../../../store/actions';
import ImportReportConfig from '../../../Report/Import/ImportReportConfig';
import ImportReportConfigState from '../../../Report/Import/ImportReportConfigState';
import Modal from '../../Modal/Modal';
import ModalStateBase from '../../Modal/ModalStateBase';
import React from 'react';
import store from '../../../../store/store';

type State = ModalStateBase & ImportReportConfigState;

interface Props {
    isValidationConfig: boolean;
    title?: string;
    skipDataSourcesValidation: boolean;
}
class ImportReportConfigModal extends React.Component<Props, State> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: false,
            json: '',
            errors: [],
            error: null,
            title: this.props.title as string
        };

        this.openListener = this.openListener.bind(this);
        this.close = this.close.bind(this);
        this.onImportSuccess = this.onImportSuccess.bind(this);
    }

    componentDidMount(): void {
        if (this.props.title) {
            this.setState({ title: this.props.title });
        }

        this.unsubscribe = store.subscribe(this.openListener);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    openListener(): void {
        let state = store.getState();

        if (state.action !== actions.importReportConfigModal.open) {
            return;
        }

        this.setState({ isOpen: true, json: '', errors: [] });
    }

    close(): void {
        this.setState({ isOpen: false });
    }

    onImportSuccess(): void {

        this.close();

        store.dispatch({ type: actions.importReportConfigModal.saveSuccess, payload: null as any });
    }

    render(): JSX.Element {

        return (
            <Modal state={this.state} close={this.close} key={this.props.title} >
                <ImportReportConfig
                    isValidationConfig={this.props.isValidationConfig}
                    state={this.state}
                    onChange={s => this.setState(s)}
                    onImportSuccess={this.onImportSuccess}
                    skipDataSourcesValidation={this.props.skipDataSourcesValidation}
                    title={this.props.title as string}
                    isOpen={this.state.isOpen}
                />
            </Modal>
        );
    }
}

export default ImportReportConfigModal;